import { render, staticRenderFns } from "./DistributionLineChart.vue?vue&type=template&id=520a1900&scoped=true"
import script from "./DistributionLineChart.vue?vue&type=script&lang=js"
export * from "./DistributionLineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a1900",
  null
  
)

export default component.exports